module.exports = __webpack_public_path__ + "img/faqs_ccs.2ba0fd35.png";